/**
 * Object xử lý event global trên toàn bộ hệ thống
 * @author DNThang - 17.03.2020
 * HTHIEP migrate sang vue3
 */
import emitter from 'tiny-emitter/instance';

export default {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

/**
 * Đối tượng liệt kê các global event đang có
 * Bắt buộc có globalEvent nào đều phải cấu hình vào đây để không bị trùng tên
 * @author DNThang - 17.03.2020
 */
const GlobalEventName = {
  changeDatabaseName: 1, // Đổi tên database đang sử dụng thì sẽ đổi lại context
  changePostedDate: 2,
  gridReload: 'gridReload',
  clearToast: 'clearToast',
  raiseLiveChatNotification: 'raiseLiveChatNotification',
  gridReloadDVC: 'gridReloadDVC', // Sự kiện load lại trang danh sách hồ sơ tại Kho bạc nhà nước (nvthinh 15.11.2023)
  // show tiến trình sao lưu dữ liệu
  showBackupProcess: 'showBackupProcess',
  // show tiến trình phục hồi dữ liệu
  showRestoreProcess: 'showRestoreProcess',
  // reload lại danh sách quản lý dữ liệu
  reloadListDbManagement: 'reloadLstDbManagement',
  // reload lại danh sách sao lưu và phục hồi
  reloadListBackupRestore: 'reloadLstBackupRestore',
  // hủy sao lưu dữ liệu
  backupDataCancel: 'backupDataCancel',
  // cập nhật % tiến trình sao lưu (realtime qua WebSocket)
  backupDataProgress: 'backupDataProgress',
  // kết thúc sao lưu dữ liệu
  backupDataCompleted: 'backupDataCompleted',
  // kết thúc tạo dữ liệu từ dữ liệu cũ
  createDataPrevYear: 'createDataPrevYear',
  // cập nhật % tiến trình phục hồi (realtime qua WebSocket)
  restoreDataProgress: 'restoreDataProgress',
  // hủy phục hồi dữ liệu
  restoreDataCancel: 'restoreDataCancel',
  // kết thức khôi phục dữ liệu
  restoreDataCompleted: 'restoreDataCompleted',
  // show tiến trình bảo trì dữ liệu
  showMaintainProcess: 'showMaintainProcess',
  // Sinh CT từ CT Salagov
  generateVoucherFromSalagov: 'generateVoucherFromSalagov',
  // Kết chuyển nhanh
  quickTransfer: 'quickTransfer',
  // Dữ liệu grid trống
  emptyDataGrid: 'emptyDataGrid',
  // load lại dữ liệu danh sách báo cáo tổng hợp
  refreshSubmitReportList: 'refreshSubmitReportList',
  //Hoàn thành ghi sổ bỏ ghi nhiều chứng từ
  postMultiCompleted: 'postMultiCompleted',
};

export {GlobalEventName};
